const indexOf = [].indexOf
const { fragment } = require('react')
const { component, dom, svg } = require('../odo/odojs/')
let ql = require('../odo/odoql/')
ql = ql.use('store').use({
  params: {
    localstore: true
  }
})
const subdomain = require('../shared/subdomain')

module.exports = component({
  query: () => {
    return {
      overview: ql.store('overview'),
      identity: ql.store('identity'),
      isshowingarchiveditems: ql.localstore('is showing archived assets'),
      portfolio: ql.store('portfolio')
    }
  },
  render: (state, params, hub) => {
    const hidearchiveditems = e => {
      e.preventDefault()
      hub.emit('hide archived items')
    }
    const hassuperpowers = state?.identity?.permissions?.includes('superpowers')
    const showcondition = params.selected === 'condition' || state?.overview?.condition_assessment_count > 0
    // TODO: enable when we have a task count
    const showplan = params.selected === 'planning' || state?.overview?.task_count > 0
    const showrisk = params.selected === 'risk' || state?.overview?.risk_assessment_count > 0
    let showcriticality = false
    // if (params.selected === 'criticality') {
    //   showcriticality = true;
    // } else if ((state.localdb != null) && state.localdb.criticality.list.length > 0) {
    //   showcriticality = true;
    // }
    let showeventtree = false
    // if (params.selected === 'eventtree') {
    //   showeventtree = true;
    // } else if (hassuperpowers && (state.localdb != null) && state.localdb.eventtree.list.length > 0) {
    //   showeventtree = true;
    // }
    return dom(fragment, [
      state.isshowingarchiveditems &&
        dom('.tabs.attention.full', [
          dom('ul', []),
          dom('ul.tabs--right', [
            dom('li.text', 'Showing archived assets.'),
            dom('li', dom('button.button.secondary', { onclick: hidearchiveditems }, 'Hide archived assets'))
          ])
        ]),
      dom('nav', [
        state.portfolio.js != null ? dom('script', { attributes: { charset: 'utf-8' } }, state.portfolio.js) : void 0,
        state.portfolio.css != null ? dom('style', { attributes: { type: 'text/css' } }, state.portfolio.css) : void 0,
        dom(
          'a.nav--logo',
          { attributes: { href: '/', rel: 'external' } },
          svg('svg', {}, svg('use', { 'xlink:href': '/assets.svg#logo-horizontal' }))
        ),
        dom('ul', [
          dom(
            `li${params.selected === 'home' ? '.selected' : ''}`,
            dom('a', { attributes: { href: `/p/${subdomain}/` } }, state.portfolio.name)
          ),
          false && params.asset != null
            ? [
                dom(
                  `li${params.selected === 'information' || params.selected === 'details' ? '.selected' : ''}`,
                  dom('a', { attributes: { href: `/p/${subdomain}/asset/${params.asset}/details` } }, 'Information')
                ),
                showcondition === true &&
                  dom(
                    `li${params.selected === 'condition' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/asset/${params.asset}/condition` } }, 'Condition')
                  ),
                showrisk === true &&
                  dom(
                    `li${params.selected === 'risk' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/asset/${params.asset}/risk` } }, 'Risk')
                  ),
                showcriticality === true &&
                  dom(
                    `li${params.selected === 'criticality' ? '.selected' : ''}`,
                    dom(
                      'a',
                      { attributes: { href: `/p/${subdomain}/asset/${params.asset}/criticality` } },
                      'Risk Assessment'
                    )
                  ),
                showeventtree === true &&
                  dom(
                    `li${params.selected === 'eventtree' ? '.selected' : ''}`,
                    dom(
                      'a',
                      { attributes: { href: `/p/${subdomain}/asset/${params.asset}/eventtree` } },
                      'Event Tree Analysis'
                    )
                  ),
                showplan === true &&
                  dom(
                    `li${params.selected === 'planning' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/asset/${params.asset}/planning` } }, 'Planning')
                  )
              ]
            : [
                dom(
                  `li${params.selected === 'information' ? '.selected' : ''}`,
                  dom('a', { attributes: { href: `/p/${subdomain}/assets` } }, 'Information')
                ),
                showcondition === true &&
                  dom(
                    `li${params.selected === 'condition' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/condition` } }, 'Condition')
                  ),
                showrisk === true &&
                  dom(
                    `li${params.selected === 'risk' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/risk` } }, 'Risk')
                  ),
                showcriticality === true &&
                  dom(
                    `li${params.selected === 'criticality' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/criticality` } }, 'Risk Assessment')
                  ),
                showeventtree === true &&
                  dom(
                    `li${params.selected === 'eventtree' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/eventtree` } }, 'Event Tree Analysis')
                  ),
                showplan === true &&
                  dom(
                    `li${params.selected === 'planning' ? '.selected' : ''}`,
                    dom('a', { attributes: { href: `/p/${subdomain}/planning` } }, 'Planning')
                  )
              ]
        ]),
        dom('ul.nav--right', [
          // TODO: bring back search
          // dom(`li${(params.selected === 'search' ? '.selected' : '')}`,
          //   dom('a', { attributes: { href: `/p/${subdomain}/search` } }, 'Search')),
          dom(
            `li${params.selected === 'settings' ? '.selected' : ''}`,
            dom('a', { attributes: { href: `/p/${subdomain}/settings/overview` } }, 'Settings')
          )
        ])
      ])
    ])
  }
})
